/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboGroupSuggestionSchema } from "./comboGroupSuggestionSchema.ts";
import { comboScheduleSchema } from "./comboScheduleSchema.ts";
import { localizationStrSchema } from "./localizationStrSchema.ts";

export const comboSuggestionSchema = z.object({
	id: z.uuid(),
	name: z.string(),
	loc_name: localizationStrSchema.describe("Util serializer for representation in swagger"),
	price: z.number(),
	image_link: z.string().nullable(),
	video_link: z.string().nullable(),
	groups: z.array(comboGroupSuggestionSchema),
	schedule: z.array(comboScheduleSchema),
});
